define('bizzabo/views/main/DashboardView',[
    'jquery',
    'Highcharts',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/config',
    'bizzabo/consts',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/SyncedCollection',
    'bizzabo/models/EventAnalytics',
    'bizzabo/views/main/MainView',
    'bizzabo/views/main/analytics/TopEntitiesTabbedView',
    'hbars!bizzabo/templates/dashboard',
    'hbars!bizzabo/templates/eventAnalyticsOverview',
    'hbars!bizzabo/templates/eventAnalyticsSharesOverview',
    'hbars!bizzabo/templates/noPlanPopUp'
], function(
    $,
    GlobalHighcharts,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    CONFIG,
    Consts,
    SyncedModel,
    SyncedCollection,
    EventAnalytics,
    MainView,
    TopEntitiesTabbedView,
    dashboardTemplate,
    eventAnalyticsOverviewTemplate,
    eventAnalyticsSharesOverviewTemplate,
    noPlanPopUpTemplate
    ) {

    var DashboardView = MainView.extend({

        tabClass : Consts.UI.tabClasses.DASHBOARD,

        prepare : function() {
            var servicePlan = Global.modelPool.getServicePlan(this.model.get("id"));
            this.prepareModels([this.model, servicePlan]);
        },

        render : function() {
            this.renderMainView();

            this.putContentView(new DashboardContentView({
                model : this.model,
                dashboardView : this
            }));
        },

        remove : function() {
            this.removeMainView();
        }
    });

    var DashboardContentView = Backbone.View.extend({

        events : {
            'click .growLink' : 'openGrowTab',
            'click a.exportAnalytics' : 'exportAnalytics'
        },

        MAX_MESSAGE_LENGTH : 250,
        REFRESH_RATE: 60000,
        lineChartView : undefined,
        impressionsMapView : undefined,

        PROVIDERS_COLORS : {
            facebook : "#3a579a",
            linkedin : "#475ff0",
            twitter : "#5ec7f2"
        },

        initialize : function() {
            Backbone.on(Consts.Notifications.mainPage.DASHBOARD_PAGE_LOADED, this.onPageLoad, this);
            var servicePlan = Global.modelPool.getServicePlan(this.model.get("id"));

            this.lineChartView = new LineChartView({
                model : this.model,
                dashboardContentView : this,
                servicePlan: servicePlan,
                el : this.$el
            });

            var impressions = new Impressions();
            impressions.eventId = this.model.get("id");
            this.impressionsMapView = new ImpressionsMapView({
                model : impressions,
                dashboardContentView : this,
                servicePlan: servicePlan,
                el : this.$el
            });

            var eventAnalytics = new EventAnalytics({
                id: this.model.get("id")
            });

            this.eventAnalyticsOverviewView = new EventAnalyticsOverviewView({
                model: eventAnalytics
            });

            this.eventAnalyticsSharesView = new EventAnalyticsSharesView({
                model: eventAnalytics
            });

            this.topEntitiesTabbedView = new TopEntitiesTabbedView({
                model : this.model
            });

            if (CONFIG.SHOW_MOCK_DATA_FOR_DEMO) {
                eventAnalytics.mockData();
                this.topEntitiesTabbedView.mockData = true;
            } else if (!this.model.isNew() && servicePlan.get('analytics')) {
                eventAnalytics.fetch();

                this.analyticsInterval = setInterval(function() {
                    eventAnalytics.fetch();
                }, this.REFRESH_RATE);
            } else {
                this.noPlanPopUpView = new NoPlanPopUpView({
                    model : servicePlan,
                    event : this.model
                });
                eventAnalytics.mockData();

                this.topEntitiesTabbedView.mockData = true;
            }
        },

        render : function() {
            var html = dashboardTemplate(this.model.toJSON());
            this.$el.html(html);
            this.topEntitiesTabbedView.setElement(this.$('.topEntitiesTabbedView'));
            this.eventAnalyticsOverviewView.setElement(this.$(".eventAnalyticsOverview"));
            this.eventAnalyticsSharesView.setElement(this.$(".eventAnalyticsSharesOverview"));
            if (!this.noPlanPopUpView) {
                this.$(".analytics-noPlanPopUp").hide();
            } else {
                this.noPlanPopUpView.setElement(this.$(".analytics-noPlanPopUp"));
            }
            return this;
        },

        remove : function() {
            Backbone.off(Consts.Notifications.mainPage.DASHBOARD_PAGE_LOADED, this.onPageLoad, this);

            this.lineChartView && this.lineChartView.remove();
            this.impressionsMapView && this.impressionsMapView.remove();
            this.eventAnalyticsOverviewView && this.eventAnalyticsOverviewView.remove();
            this.eventAnalyticsSharesView && this.eventAnalyticsSharesView.remove();
            this.noPlanPopUpView && this.noPlanPopUpView.remove();
            this.analyticsInterval && clearInterval(this.analyticsInterval);

            this.off();
            this.$el.remove();
        },

        onPageLoad : function() {
            this.lineChartView.render();
            this.impressionsMapView.firstRender();
            this.eventAnalyticsOverviewView.render();
            this.eventAnalyticsSharesView.render();
            this.noPlanPopUpView && this.noPlanPopUpView.render();
            this.topEntitiesTabbedView.render();
        },

        exportAnalytics: function() {
            var eventId = this.model.id;
            var url = CONFIG.SERVER_URL + '/api/v1/analytics/' + eventId + '/export.xls';
            window.open(url, '_blank');
        }
    });

    var LineChartView = Backbone.View.extend({

        events : {
            'click a.refreshLineChartBtn' : 'refresh',
            'click .legendBtn' : 'formLegendBtnClicked'
        },

        lineChart : undefined,
        impressionsViews : {},
        maxLineLength : 0,

        initialize : function() {
            var linkedinImpressionsView = new ImpressionsView({
                model : new ImpressionSums({
                    provider : Consts.SocialShare.Providers.LINKEDIN,
                    eventId : this.model.get("id")
                }),
                lineChartView : this
            });
            var facebookImpressionsView = new ImpressionsView({
                model : new ImpressionSums({
                    provider : Consts.SocialShare.Providers.FACEBOOK,
                    eventId : this.model.get("id")
                }),
                lineChartView : this
            });
            var twitterImpressionsView = new ImpressionsView({
                model : new ImpressionSums({
                    provider : Consts.SocialShare.Providers.TWITTER,
                    eventId : this.model.get("id")
                }),
                lineChartView : this
            });
            this.impressionsViews[linkedinImpressionsView.model.getName()] = linkedinImpressionsView;
            this.impressionsViews[facebookImpressionsView.model.getName()] = facebookImpressionsView;
            this.impressionsViews[twitterImpressionsView.model.getName()] = twitterImpressionsView;
        },

        remove : function() {
            _.chain(this.impressionsViews).values().invoke('remove');
            this.impressionsViews = {};

            this.lineChart.destroy();
            this.off();
            this.$el.remove();
        },

        render : function() {
            var thisView = this;
            this.lineChart = new Highcharts.Chart({
                chart : {
                    renderTo : 'lineChart',
                    type : 'spline',
                    backgroundColor : "transparent"
                },
                xAxis : {
                    type : 'datetime',
                    dateTimeLabelFormats : {
                        day : '%b %e ',
                        week : '%b %e'
                    },
                    minTickInterval : 24 * 3600 * 1000, // day
                    minorTickInterval : "auto",
                    tickLength : 20,
                    minorTickLength : 8,
                    tickWidth : 2,
                    minorTickWidth : 2,
                    tickColor : "#dddddd",
                    minorTickColor : "#dddddd",
                    tickPosition : "inside",
                    minorTickPosition : "inside",
                    lineColor : null,
                    gridLineColor : null,
                    minorGridLineColor : null,
                    labels : {
                        style : {
                            color : "#888889",
                            "font-size" : "16px",
                            "font-family" : "arial",
                            "font-weight" : "normal"
                        }
                    }
                },
                yAxis : {
                    title : {
                        text : null
                    },
                    gridLineColor : "transparent",
                    min : 0,
                    showFirstLabel : false,
                    labels : {
                        style : {
                            color : "#888889",
                            "font-size" : "16px",
                            "font-family" : "arial",
                            "font-weight" : "normal"
                        }
                    }
                },
                tooltip : {
                    shared : false,
                    useHTML : true,
                    formatter : function() {
                        return thisView.formatTooltip(this);
                    }
                },
                title : {
                    text : null
                },
                legend : {
                    enabled : false
                },
                credits : {
                    enabled : false
                },
                series : []
            });

            this.refresh();
            return this;
        },

        formLegendBtnClicked : function(eventObject) {
            var el = $(eventObject.currentTarget);
            var providerDisplayName = el.find("p").eq(0).html();
            var shouldDisable = !el.hasClass("disabled");
            el.toggleClass("disabled");
            var impressionsView = this.impressionsViews[providerDisplayName];
            var method = shouldDisable ? 'hide' : 'show';
            impressionsView.series && impressionsView.series[method]();

            var mapView = this.options.dashboardContentView.impressionsMapView;
            mapView.toggleMarkers(impressionsView.model.get("provider"), !shouldDisable);
        },

        formatTooltip : function(point) {
            var dateString = Highcharts.dateFormat("%A, %b %e", point.x, true);
            var impressionsView = this.impressionsViews[point.series.name];
            var provider = impressionsView.model.get("provider");
            var imgName = "images/dashboard/btn_" + provider + ".png";
            return '<div class="toolTip"><img src="' + imgName + '" />' + dateString + '<br/>' + point.y + ' impressions</div>';
        },

        refresh : function() {
            this.lineChart.showLoading();
            var thisView = this;

            if (this.model.isLive() && this.options.servicePlan.get('analytics')) {
                var done = _.after(_.size(this.impressionsViews), function() {
                    if (thisView.totalShares() > 0) {
                        thisView.allLinesLoaded();
                    } else {
                        thisView.putNoDataOverlay();
                    }
                });

                for (var i in this.impressionsViews) {
                    this.impressionsViews[i].model.fetch({
                        success : done
                    });
                }
            } else {
                this.putNoDataOverlay();
            }
        },

        mockData : function(provider) {
            var emptyData = {
                facebook : [1082, 5723, 9934, 5207, 5905, 6540, 5325, 7142, 4578, 10888, 5966, 8433, 6337, 6576, 9792, 7644, 11493, 7941, 10521, 8064, 10946, 8153, 8755, 8900, 9897, 7496, 4510, 2842, 2573, 3290, 4053, 4717, 3762, 3358, 2965, 6685, 2320, 2441, 4803, 3416, 3460, 3551, 3864, 3326, 2135, 4286, 5170, 7945, 7390, 6823, 4031],
                twitter : [1945, 5049, 2926, 10190, 7576, 7572, 7079, 7443, 4509, 6022, 7297, 5413, 7273, 5195, 9098, 9970, 8511, 7139, 8500, 11512, 11799, 9726, 5418, 8821, 6179, 8294, 4191, 1659, 3093, 2982, 3864, 2613, 2868, 3127, 2569, 4075, 3282, 3119, 3976, 3374, 3110, 5228, 1488, 4023, 4278, 5434, 7092, 5684, 7127, 5736, 3159],
                linkedin : [972, 4841, 4712, 11082, 3701, 6401, 6115, 5480, 4705, 3371, 6371, 6612, 5785, 5460, 9759, 7090, 8655, 8986, 9346, 7282, 7901, 7319, 10763, 12185, 5671, 6905, 2265, 2949, 3133, 3013, 2002, 3353, 2560, 3097, 1342, 2741, 3434, 1690, 2214, 2651, 2582, 3528, 3207, 2900, 5914, 4146, 6782, 6186, 4527, 6045, 5916]
            };

            var date = new Date(new Date() - emptyData[provider].length);
            return _(emptyData[provider]).map(function(value) {
                date.setDate(date.getDate() + 1);
                return {
                    date : date.getTime(),
                    value : value
                };
            });
        },

        putNoDataOverlay : function() {
            for (var i in this.impressionsViews) {
                var thisImpressionView = this.impressionsViews[i];
                var thisProvider = thisImpressionView.model.get("provider");
                thisImpressionView.model.set({
                    data : this.mockData(thisProvider)
                });
            }
            this.allLinesLoaded();

            if (CONFIG.SHOW_MOCK_DATA_FOR_DEMO) {
                return;
            }

            this.$(".noDataOverlay").show();
        },

        totalShares : function() {
            return _.chain(this.impressionsViews).values().reduce(function(sum, view) {
                return sum + view.model.total();
            }, 0).value();
        },

        allLinesLoaded : function(isExampleData) {
            if (Global.appView.mainView.tabClass !== Consts.UI.tabClasses.DASHBOARD) {
                return;
            }

            for (var i in this.impressionsViews) {
                var impressionView = this.impressionsViews[i];
                this.lineLoaded(impressionView.model, this.totalShares());
            }

            this.lineChart.hideLoading();
        },

        lineLoaded : function(model, totalShares) {
            var lineLength = model.get('data') ? model.get('data').length : 0;
            this.maxLineLength = Math.max(lineLength, this.maxLineLength);

            this.$(".totalSharesToday").html(UTILS.getNumberWithCommas(totalShares));

            if (_.has(model, "attributes")) {
                var provider = model.get("provider");
                var totalSharesForModel = (lineLength > 0) ? model.total() : 0;
                this.$("." + provider + "SharesToday").html(UTILS.getNumberWithCommas(totalSharesForModel));

                var rsvpCount = this.model.get("aggregated-data-rsvp-count");
                if (rsvpCount) {
                    var avg = Math.round(totalShares / rsvpCount * 100) / 100;
                    this.$(".sharesPerPerson").html(avg);
                }
            }
        }

    });

    var ImpressionsView = Backbone.View.extend({

        series : undefined,

        initialize : function() {
            this.listenTo(this.model, "change:data", this.render);
        },

        render : function() {
            var parent = this.options.lineChartView;
            var chart = parent.lineChart;
            if (chart) {
                if (this.series) {
                    var data = this.model.transformData();
                    this.series.setData(data);
                } else {
                    var series = this.model.toSeries();
                    series["color"] = this.options.lineChartView.options.dashboardContentView.PROVIDERS_COLORS[this.model.get("provider")];
                    this.series = chart.addSeries(series);
                }
            }

            return this;
        }
    });

    var ImpressionSums = SyncedModel.extend({

        PROVIDERS_DISPLAY_NAMES : {
            facebook : "Facebook",
            linkedin : "LinkedIn",
            twitter : "Twitter"
        },

        PROVIDERS_ICON_URLS : {
            facebook : 'url(http://www.highcharts.com/demo/gfx/sun.png)',
            linkedin : 'url(http://www.highcharts.com/demo/gfx/sun.png)',
            twitter : 'url(http://www.highcharts.com/demo/gfx/sun.png)'
        },

        defaults : {
            'interval' : Consts.SocialShare.Interval.DAILY
        },
        summedData : undefined,

        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getSocialShareImpressions(model.get('eventId'), model.get("provider"), model.get("interval"), function(data) {
                    data = (data && data.impressions) ? UTILS.ensureArray(data.impressions) : undefined;
                    options.success && options.success(data, options);
                    model.setFlagsAfterSync();
                }, options.error);
            }
        },

        parse : function(response) {
            return {
                data : response,
                interval : this.get("interval"),
                provider : this.get("provider")
            };
        },

        toSeries : function() {
            var res = {
                name : this.getName(),
                marker : {
                    symbol : 'circle'
                },
                data : this.transformData(),
                index : this.getIndex()
            };
            return res;
        },

        getName : function() {
            return this.PROVIDERS_DISPLAY_NAMES[this.get("provider")];
        },

        getIndex : function() {
            var keys = _.keys(Consts.SocialShare.Providers);
            return _.indexOf(keys, this.get("provider"));
        },

        transformData : function() {
            var sum = 0;
            var res = _(this.get('data')).map(function(item) {
                var value = item.value || 0;
                sum += value;
                return [item.date, sum];
            });
            return res;
        },

        total : function() {
            return _.reduce(this.get('data'), function(sum, item) {
                var value = item.value || 0;
                return sum + value;
            }, 0);
        }
    });

    var ImpressionsMapView = Backbone.View.extend({

        events : {
            'click a.refreshImpressionsMapBtn' : 'refresh'
        },

        loading : false,
        impressionsMap : undefined,
        markers : {},
        mapStyles : [
            {
                featureType : "administrative.land_parcel",
                stylers : [
                    {
                        visibility : "off"
                    }
                ]
            },
            {
                featureType : "water",
                stylers : [
                    {
                        visibility : "on"
                    },
                    {
                        saturation : 31
                    },
                    {
                        lightness : 39
                    }
                ]
            },
            {
                featureType : "road.highway",
                stylers : [
                    {
                        visibility : "simplified"
                    },
                    {
                        lightness : 18
                    }
                ]
            }
        ],
        PROVIDERS_RADIUS_COEFFICIENT : { // radius = number_of_connections / coefficient
            facebook : 20,
            linkedin : 20,
            twitter : 20
        },
        emptyData : [
            {
                lat : 40.769362,
                long : -73.982964,
                connections : 500,
                provider : Consts.SocialShare.Providers.LINKEDIN
            },
            {
                lat : 40.809912,
                long : -73.958931,
                connections : 1000,
                provider : Consts.SocialShare.Providers.FACEBOOK
            },
            {
                lat : 40.753759,
                long : -73.997383,
                connections : 800,
                provider : Consts.SocialShare.Providers.TWITTER
            },
            {
                lat : 40.723323,
                long : -73.9888,
                connections : 700,
                provider : Consts.SocialShare.Providers.LINKEDIN
            },
            {
                lat : 40.742055,
                long : -73.980217,
                connections : 900,
                provider : Consts.SocialShare.Providers.FACEBOOK
            }
        ],

        remove : function() {
            this.off();
            this.$el.remove();
        },

        render : function() {
            this.impressionsMap = new google.maps.Map(this.$('#impressionsMap').get(0), {
                zoom : 6,
                center : new google.maps.LatLng(34.5, 32.6), // todo
                mapTypeId : google.maps.MapTypeId.ROADMAP,
                panControl : false,
                streetViewControl : false,
                mapTypeControl : false,
                zoomControl : true,
                styles : this.mapStyles,
                zoomControlOptions : {
                    style : google.maps.ZoomControlStyle.SMALL,
                    position : google.maps.ControlPosition.LEFT_CENTER
                }
            });

            this.refresh();
            return this;
        },

        firstRender : function() {
            var thisView = this;
            if (typeof google === 'undefined') {
                $.getScript('https://www.google.com/jsapi?key=' + CONFIG.GOOGLE_MAPS_API_KEY, function() {
                    thisView.firstRender();
                });
                return;
            }

            if (this.loading) {
                return;
            }
            this.loading = true;

            google.load("maps", "3", {
                callback : function() {
                    thisView.render();
                },
                other_params : "libraries=visualization&sensor=false&key=" + CONFIG.GOOGLE_MAPS_API_KEY
            });
        },

        refresh : function() {
            var thisView = this;

            if (!this.options.dashboardContentView.model.isLive() || !this.options.servicePlan.get('analytics')) {
                this.putNoDataOverlay();
                return;
            }

            this.model.fetch({
                success : function() {
                    thisView.drawMarkers();
                }
            });
        },

        putNoDataOverlay : function(overrideModels) {
            if (this.model.length === 0 || overrideModels) {
                this.model.reset();
                this.model.add(this.emptyData);
            }
            this.drawMarkers();

            if (CONFIG.SHOW_MOCK_DATA_FOR_DEMO) {
                return;
            }

            this.$(".noDataOverlay").show();
        },

        /*
         Taken from: http://blog.shamess.info/2009/09/29/zoom-to-fit-all-markers-on-google-maps-api-v3/
         */
        zoomToFitAllMarkers : function() {
            //  Make an array of the LatLng's of the markers you want to show
            var LatLngList = [];
            for (var j in this.markers) {
                var thisMarkers = this.markers[j];
                for (var jj in thisMarkers) {
                    var marker = thisMarkers[jj];
                    LatLngList.push(marker.getPosition());
                }
            }
            //  Create a new viewpoint bound
            var bounds = new google.maps.LatLngBounds();
            //  Go through each...
            for (var i = 0, LtLgLen = LatLngList.length; i < LtLgLen; i++) {
                //  And increase the bounds to take this point
                bounds.extend(LatLngList[i]);
            }
            //  Fit these bounds to the map
            this.impressionsMap.fitBounds(bounds);
        },

        toggleMarkers : function(provider, isVisible) {
            var markers = this.markers[provider];
            for (var i in markers) {
                var marker = markers[i];
                marker.setVisible(isVisible);
            }
        },

        drawMarkers : function() {
            var thisView = this;
            this.markers = {};

            var createLatLngToPreventOverlap = function(model) {
                var lat = parseFloat(model.get('lat'));
                var lon = parseFloat(model.get('long'));
                return new google.maps.LatLng(lat, lon);
            };

            var getCircle = function(model) {
                var provider = model.get("provider");
                var providerColor = thisView.options.dashboardContentView.PROVIDERS_COLORS[provider];
                var providerRadiusCoefficient = thisView.PROVIDERS_RADIUS_COEFFICIENT[provider];
                return {
                    path : google.maps.SymbolPath.CIRCLE,
                    fillColor : providerColor,
                    fillOpacity : 0.2,
                    scale : model.get("connections") / providerRadiusCoefficient,
                    strokeColor : providerColor,
                    strokeWeight : 0.5
                };
            };

            var createMarker = function(model) {
                var latLng = createLatLngToPreventOverlap(model);
                var circle = getCircle(model);
                var provider = model.get("provider");
                var title = provider === "twitter" ? "tweet" : provider + " share";

                return new google.maps.Marker({
                    position : latLng,
                    map : thisView.impressionsMap,
                    title : title,
                    icon : circle
                });
            };

            var noMarkers = true;
            for (var i in thisView.model.models) {
                var model = thisView.model.at(i);
                if (model.get("lat") && model.get("long")) {
                    var marker = createMarker(model);
                    marker.model = model;
                    var thisMarkers = thisView.markers[model.get("provider")] || [];
                    if (thisMarkers.length === 0) {
                        thisView.markers[model.get("provider")] = thisMarkers;
                    }
                    thisMarkers.push(marker);
                    noMarkers = false;
                }
            }

            if (noMarkers) {
                thisView.putNoDataOverlay(true);
            }
            thisView.zoomToFitAllMarkers();
        }
    });

    var Impression = SyncedModel.extend({});

    var Impressions = SyncedCollection.extend({

        model : Impression,

        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getSocialShareAnalytics(this.eventId, undefined, undefined, function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            }
        }
    });

    var EventAnalyticsOverviewView = Backbone.View.extend({
        initialize: function() {
            this.listenTo(this.model, "change", this.render);
        },

        render: function() {
            this.$el.html(eventAnalyticsOverviewTemplate(this.model.toJSON()));
            return this;
        }
    });

    var EventAnalyticsSharesView = Backbone.View.extend({

        initialize: function() {
            this.listenTo(this.model, "change", this.render);
        },

        render: function() {
            this.$el.html(eventAnalyticsSharesOverviewTemplate(this.model.toJSON()));
            return this;
        }

    });

    var NoPlanPopUpView = Backbone.View.extend({

        render: function() {
            this.$el.html(noPlanPopUpTemplate({
                upgradeUrl : '/account/cart?' + this.model.upgradeUrlQuery(),
                isNewWithPackage : (this.options.event.isNew() && this.model.get('analytics'))
            }));
            return this;
        },

        remove: function () {
            this.$el.remove();
            this.stopListening();
            return this;
        }

    });

    return DashboardView;
    
});
